import { Cherry, Droplets, Flower2, Leaf, Nut, Palette, Sparkles, Wind } from "lucide-react";
import { site } from "@/content/liane-site.ar";
import { useReveal } from "@/hooks/use-reveal";

const iconMap = {
  leaf: Leaf,
  droplet: Droplets,
  sparkles: Sparkles,
  olive: Flower2,
  cocoa: Cherry,
  almond: Nut,
  aroma: Wind,
  palette: Palette,
} as const;

export function Ingredients() {
  const reveal = useReveal<HTMLDivElement>();

  return (
    <section id="ingredients" className="py-16 lg:py-24">
      <div ref={reveal.ref} className={`container-liane ${reveal.className}`}>
        <h2 className="text-center text-2xl font-bold text-l-primary sm:text-3xl lg:text-4xl">
          {site.ingredients.title}
        </h2>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {site.ingredients.items.map((item) => {
            const Icon = iconMap[item.icon as keyof typeof iconMap] ?? Leaf;
            return (
              <article
                key={item.name}
                className="rounded-3xl border border-l-border bg-l-card p-7 text-start shadow-l-soft transition-shadow hover:shadow-l-lift"
              >
                <span className="grid size-12 place-items-center rounded-2xl bg-l-accent-soft text-l-accent-strong-foreground">
                  <Icon className="size-6 text-l-accent-strong" aria-hidden="true" />
                </span>
                <h3 className="mt-5 text-lg font-bold text-l-primary">{item.name}</h3>
                <p className="mt-2 text-sm leading-7 text-l-muted-foreground sm:text-base">
                  {item.text}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
